
import { DEFAULT_MODAL_MANAGER_CONTEXT } from "constants/context";
import { createContext } from "react";

const ModalManagerContext = createContext(DEFAULT_MODAL_MANAGER_CONTEXT)

export default ModalManagerContext